import styled, { css } from 'styled-components';
import { Col, Button, Tooltip } from 'antd';
import ButtonDefault from '@/components/ui/ButtonDefault';

export const Table = styled(Col)<{ $backGroundColor?: string }>`
	.ant-table {
		border-radius: 0 0 10px 10px !important;
		.ant-table-thead
			> tr
			> th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not(
				[colspan]
			)::before {
			background-color: ${({ theme }) => theme.palette.secondary.white};
		}
		.ant-table-wrapper {
			display: flex;
			justify-content: center;
			.ant-spin-nested-loading {
				width: 25rem;
			}
		}
		.ant-table-tbody {
			background-color: ${({ $backGroundColor }) => $backGroundColor ?? 'unset'};
			tr {
				background-color: ${({ theme }) => theme.palette.secondary.white};
			}
			.file-columns {
				text-align: start !important;
			}
			.ant-table-selection-column {
				padding-left: 25px;
			}
			.ant-table-row:last-child {
				.ant-table-cell:first-child {
					border-radius: 0 0 0 10px;
				}
				.ant-table-cell:last-child {
					border-radius: 0 0 10px 0;
				}
			}
			td {
				border-top: 1px solid transparent;
			}
			td:first-child {
				border-left: 1px solid transparent;
			}
			td:last-child {
				border-right: 1px solid transparent;
			}
			.ant-table-row-selected {
				td:first-child {
					border-left: 1px solid ${({ theme }) => theme.colors.primary};
					border-top-left-radius: ${({ theme }) => theme.border.border_radius.br_lg} !important;
					border-bottom-left-radius: ${({ theme }) => theme.border.border_radius.br_lg};
				}

				td {
					background-color: ${({ theme }) => theme.palette.primary['50']} !important;
					border-top: 1px solid ${({ theme }) => theme.colors.primary};
					border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
				}
			}
		}
		.ant-table-thead {
			th {
				background-color: ${({ theme }) => theme.colors.primary};
				color: ${({ theme }) => theme.palette.secondary.white};
				.ant-typography {
					color: ${({ theme }) => theme.palette.secondary.white};
				}
			}
			.file-columns {
				padding-right: 60px;
			}
			.ant-table-cell::before {
				background-color: ${({ theme }) => theme.palette.secondary['50']};
			}
			.ant-table-cell:first-child {
				border-radius: 8px 0 0 0;
			}
			.ant-table-cell:last-child {
				border-radius: 0 8px 0 0;
			}
		}
	}
`;

export const CustomTitle = styled.h2`
	${({ theme }) => css`
		${{ ...theme.fonts.heading.md }}
	`}
`;

export const CustomParagraph = styled.p`
	${({ theme }) => css`
		${{ ...theme.fonts.body.md }}
	`}
`;

export const CustomInput = styled.input<{ $borderRadius?: string }>`
	font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
	height: 40px;
	border-radius: ${({ $borderRadius }) => $borderRadius ?? '7px'};

	.ant-input {
		margin-left: 7px;
	}
`;

export const CustomButton = styled(Button)<{ $borderRadius?: string }>`
	width: 100%;
	border-radius: ${({ $borderRadius }) => $borderRadius ?? '7px'};

	svg:hover {
		fill: ${({ theme }) => theme.colors.primary};
	}
`;

export const CustomTableTitle = styled.span`
	font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_md};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_lg};
	font-weight: ${({ theme }) => theme.sizes.weights.semibold};
`;

export const CustomTooltip = styled(Tooltip)`
	/* Popup style */
	.ant-tooltip-inner {
		background-color: #333;
		color: ${({ theme }) => theme.palette.secondary.white};
		font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
		border-radius: ${({ theme }) => theme.border.border_radius.br_sm};
	}
`;

export const EllipsisText = styled.span`
	display: inline-block;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const CustomButtonDefault = styled(ButtonDefault)`
	margin: 10px 0;

	&.active {
		background-color: ${({ theme }) => theme.palette.primary[100]} !important;
		border-color: ${({ theme }) => theme.palette.primary[100]} !important;
		color: ${({ theme }) => theme.palette.primary.default} !important;
	}
`;
